import React from 'react';

const Message = () => {
    return (
      <div>
        <article className="chairman-main-message pe-xl-4">
          <h3 className="chairman-name fw-bold">Dr. Md. Sazzad Hossain</h3>
          Computer Science and Engineering is at the intellectual forefront of
          the digital revolution that will define the 21st century. That
          revolution is in its early stages but is visible all around us. New
          scientific, economic and social paradigms are arising from computing
          science and being felt across all sectors of the economy and society
          at large. For accepting this technological challenge of 21st century,
          the Department of Computer Science and Engineering is one of the most
          pioneering soloist of MBSTU and the country since its commencement in
          2003. The department is keen on pushing the boundaries of traditional
          education system and it is the optimum combination of knowledge
          generation and application that makes the distinctive feature of the
          Department.
        </article>
      </div>
    );
};

export default Message;